import { Component, OnInit, Input, EventEmitter, Output, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrimengModule } from '@app/shared/primeng.module';
import { ScaffoldDialogRef } from '@app/framework/dialog/scaffold-dialog.service';

@Component({
  selector: 'scaffold-dialog',
  templateUrl: './scaffold-dialog.component.html',
  styleUrls: ['./scaffold-dialog.component.scss'],
  standalone: true,
  imports: [CommonModule, PrimengModule],
})
export class ScaffoldDialogComponent implements OnInit {
  /**Title for Dialog*/
  @Input() title: string;
  /**Size of dialog 'wide' = 90vw, 'half' = 50vw*/
  @Input() size: string = '';
  /**Set overflow of content to hidden*/
  @Input() fit: boolean = false;
  /** fill the height of the window*/
  @Input() fullHeight: boolean;
  /** Whether it will have buttons layed out at the end of the modal or by default spread between evenly with the available space*/
  @Input() buttonsFlexEnd: boolean = false;
  @Input() buttonsCenter: boolean = false;
  /** Show a close button for the modal*/
  @Input() showCloseButton: boolean = false;
  /** Show a collapse button for the modal*/
  @Input() showCollapseButton: boolean = false;
  /** take true full view of the window*/
  @Input() fullView: boolean = false;
  /** optional max width of view*/
  @Input() maxWidth;
  /** optional min width of view*/
  @Input() minWidth;
  @Output() close = new EventEmitter<any>();

  constructor(@Optional() private dialogRef: ScaffoldDialogRef) {}

  ngOnInit(): void {}

  handleClose() {
    this.dialogRef?.close();
    this.close.emit();
  }
}
